"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEstesStrategy = void 0;
const constants_1 = require("../constants");
const validationHelpers_1 = require("../common/validationHelpers");
const ESTES_PRO_NUMBER_LENGTH = 10;
const createEstesStrategy = (options) => {
    const { metaData } = options !== null && options !== void 0 ? options : {};
    const { terminalCode } = metaData !== null && metaData !== void 0 ? metaData : {};
    const getProNumberWithCheckDigit = ({ proNumber, }) => {
        if (proNumber === "0") {
            return "";
        }
        return proNumber !== null && proNumber !== void 0 ? proNumber : "";
    };
    const validateProNumber = (validationInput) => {
        const { proNumber } = validationInput;
        const actualLength = proNumber.length;
        // Check if length is exactly 10 (Estes uses 10-digit pro numbers)
        if (actualLength !== ESTES_PRO_NUMBER_LENGTH) {
            return (0, validationHelpers_1.createValidationError)(constants_1.PRO_VALIDATION_ERROR_TYPES.PRO_NUMBER_LENGTH_MISMATCH, {
                expectedLength: ESTES_PRO_NUMBER_LENGTH,
            });
        }
        // Check if terminalCode is provided and validate prefix match
        if (terminalCode && terminalCode.length >= 3) {
            const terminalPrefix = terminalCode.substring(0, 3);
            const firstThreeDigits = proNumber.substring(0, 3);
            if (/^\d{3}$/.test(terminalPrefix)) {
                if (firstThreeDigits !== terminalPrefix) {
                    return (0, validationHelpers_1.createValidationError)(constants_1.PRO_VALIDATION_ERROR_TYPES.TERMINAL_MISMATCH);
                }
            }
        }
        return null;
    };
    const isTempProNumber = (proNumber) => {
        return false;
    };
    const getCheckDigit = (_proId) => "";
    return {
        getProNumberWithCheckDigit,
        validateProNumber,
        isTempProNumber,
        getCheckDigit,
    };
};
exports.createEstesStrategy = createEstesStrategy;
